import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTag, faShoppingCart } from '@fortawesome/free-solid-svg-icons';
import Card from '../../../components/common/cards/index';
// import image1 from "../../../assests/images/image1.png";
// import image2 from "../../../assests/images/images2.png";
// import image3 from "../../../assests/images/image3.png";
// import image4 from "../../../assests/images/image4.png";
// import image5 from "../../../assests/images/image5.png";
// import image6 from "../../../assests/images/image6.png";
import image1 from "../../../assests/wood-image/products/door/image-1.png";
import image2 from "../../../assests/wood-image/products/door/image-2.png";
import image3 from "../../../assests/wood-image/products/door/image-3.png";
import image4 from "../../../assests/wood-image/products/door/image-4.png";
import image5 from "../../../assests/wood-image/products/door/image-5.png";
import image6 from "../../../assests/wood-image/products/door/image-6.png";
import image7 from "../../../assests/wood-image/products/door/image-10.png";
import image8 from "../../../assests/wood-image/products/door/image-8.png";
import image9 from "../../../assests/wood-image/products/door/image-9.png";
import '../products.css';
const Doors = () => {
    const productData = [
        { id: 1, name: 'Modern Door', price: '$199.99', shortDescription: 'A stylish modern door for your home.', image: image1 },
        { id: 2, name: 'Wooden Door', price: '$89.99', shortDescription: 'A comfortable wooden chair for your living room.', image: image2 },
        { id: 3, name: 'Carved Door Panel', price: '$299.99', shortDescription: 'A beautiful table made from high-quality wood.', image: image3 },
        { id: 4, name: 'Wooden Door with Carving', price: '$149.99', shortDescription: 'A spacious bookshelf to organize your books.', image: image4 },
        { id: 5, name: 'Classic Cabinet', price: '$399.99', shortDescription: 'A classic cabinet with ample storage space.', image: image5 },
        { id: 6, name: 'Wooden Carved Swing Seat', price: '$249.99', shortDescription: 'A relaxing swing for your backyard.', image: image6 },
        { id: 6, name: 'Wooden Carved', price: '$249.99', shortDescription: 'A relaxing swing for your backyard.', image: image7 },
        { id: 7, name: 'Carved Wooden Doors', price: '$249.99', shortDescription: 'A relaxing swing for your backyard.', image: image8 },
        { id: 9, name: 'Traditional Wooden', price: '$249.99', shortDescription: 'A relaxing swing for your backyard.', image: image9 },
    ];

    return (
        <div className="container mt-0 " style={{padding:'120px 10px '}}>
            <div className="banner animate__animated animate__bounceIn py-5" >
                <h1>Exclusive Offers on Doors</h1>
                <p>Up to 50% off on selected items!</p>
                <div className="icons">
                    <FontAwesomeIcon icon={faTag} className="icon" />
                    <FontAwesomeIcon icon={faShoppingCart} className="icon" />
                </div>
                <div className='text-center' id='doors'><a href='#doors' className="btn btn-danger" style={{width:'200px'}}>Shop Now</a></div>
                
            </div>
            <h2 className="my-4" >Doors</h2>
            <div className="row" >
                {productData.map(product => (
                    <div key={product.id} className="col-lg-4 col-md-6 mb-4">
                        <Card 
                            image={product.image} 
                            // name={product.name} 
                            // price={product.price} 
                            // shortDescription={product.shortDescription} 
                            productId={product.id} 
                            title="Doors" 
                        />
                    </div>
                ))}
            </div>
        </div>
    );
};

export default Doors;
